<div class="fancy_rows" *ngFor="let item of fancyData; let i=index;trackBy:trackByIndex;">
    <div class="" *ngIf="isInclude(tabVal, item?.sort_priority)">
        <div class="row align-items-center mx-0" *ngIf="isFancy ? item.fancy_type != 'LINE' : item.fancy_type == 'LINE'">
            <div class="col-md-5 col-7 align-items-center d-flex position-relative">
                <p class="team-name">
                    <img class="img-fluid" *ngIf="!multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'save')" src="https://speedcdn.io/assets/kesar-client/icons/star-red-inactive.png">
                    <img class="img-fluid" *ngIf="multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'remove')" src="https://speedcdn.io/assets/kesar-client/icons/star-red-active.png">
                    {{item.name}}
                    <span class="mrkt-volume" *ngIf="expo[item?.market_id] && expo[item?.market_id][item?.selection_id]" [ngClass]="expo[item?.market_id][item?.selection_id]?.expose > 0 ? 'green' : 'red'">
                        {{fixedPostDecimal(expo[item?.market_id][item?.selection_id]?.expose)}}
                    </span>
                    <a class="mobile-tooltip" data-toggle="tooltip" data-placement="top" title="max:{{item?.min_bet}} | mkt:{{item?.max_bet}}">
                        <i class="fa fa-info-circle mdi mdi-information"></i>
                    </a>
                </p>
                <a class="bookbtn" *ngIf="expo[item?.market_id] && expo[item?.market_id][item?.selection_id]" (click)="fancyRunPosition(bookModal, item)">
                    <img src="https://speedcdn.io/assets/kesar-client/icons/stair.png">
                </a>
            </div>

            <div class="col-md-7 col-5 position-relative px-0 text-right text-lg-center">

                <div class="odds-bl">
                    <div class="btn-group d-none d-sm-flex"></div>
                    <div class="btn-group">
                        
                        <!-- <button type="button" class="bl-btns blue">1000.00 <span>500.00</span></button>
                        <button type="button" class="bl-btns red">1000.00 <span>500.00</span></button> -->

                        <div class="fancy_six_odds">
                            <div>
                                <!-- 1st odds -->
                                <button class="bl-btns red {{odds[item?.market_id]?.lKey}}" (click)="openBetPlace(item, odds[item?.market_id], '', odds[item?.market_id], '', 'l3', 'fancy')">
                                    {{odds[item?.market_id]?.lay_price ? odds[item?.market_id]?.lay_price : '-'}}
                                    <span>{{odds[item?.market_id]?.lay_rate ? odds[item?.market_id]?.lay_rate : '-'}}</span>
                                </button>
                                <button class="bl-btns blue {{odds[item?.market_id]?.bKey}}" (click)="openBetPlace(item, odds[item?.market_id], '', odds[item?.market_id], '', 'b1', 'fancy')">
                                    {{odds[item?.market_id]?.back_price?odds[item?.market_id]?.back_price : '-'}}
                                    <span>{{odds[item?.market_id]?.back_rate ? odds[item?.market_id]?.back_rate : '-'}}</span>
                                </button>
                            </div>
                            <div>
                                <!-- 2nd odds -->
                                <button class="bl-btns red {{odds[item?.market_id]?.lKey1}}" *ngIf="odds[item?.market_id]?.active_rate1 == 1" (click)="openBetPlace(item, odds[item?.market_id], '1', odds[item?.market_id], '1', 'l2', 'fancy')">
                                    {{odds[item?.market_id]?.lay1_price ? odds[item?.market_id]?.lay1_price : '-'}}
                                    <span>{{odds[item?.market_id]?.lay1_rate ? odds[item?.market_id]?.lay1_rate : '-'}}</span>
                                </button>
                                <button class="bl-btns blue {{odds[item?.market_id]?.bKey1}}" *ngIf="odds[item?.market_id]?.active_rate1 == 1" (click)="openBetPlace(item, odds[item?.market_id], '1', odds[item?.market_id], '1', 'b2', 'fancy')">
                                    {{odds[item?.market_id]?.back1_price ? odds[item?.market_id]?.back1_price : '-'}}
                                    <span>{{odds[item?.market_id]?.back1_rate ? odds[item?.market_id]?.back1_rate : '-'}}</span>
                                </button>
                            </div>
                            <div>
                                <!-- 3rd odds -->
                                <button class="bl-btns red {{odds[item?.market_id]?.lKey2}}" *ngIf="odds[item?.market_id]?.active_rate2 == 1" (click)="openBetPlace(item, odds[item?.market_id], '2', odds[item?.market_id], '2', 'l1', 'fancy')">
                                    {{odds[item?.market_id]?.lay2_price ? odds[item?.market_id]?.lay2_price : '-'}}
                                    <span>{{odds[item?.market_id]?.lay2_rate ? odds[item?.market_id]?.lay2_rate : '-'}}</span>
                                </button>
                                <button class="bl-btns blue {{odds[item?.market_id]?.bKey2}}" *ngIf="odds[item?.market_id]?.active_rate2 == 1" (click)="openBetPlace(item, odds[item?.market_id], '2', odds[item?.market_id], '2', 'b3', 'fancy')">
                                    {{odds[item?.market_id]?.back2_price ? odds[item?.market_id]?.back2_price : '-'}}
                                    <span>{{odds[item?.market_id]?.back2_rate ? odds[item?.market_id]?.back2_rate : '-'}}</span>
                                </button>
                            </div>
                        </div>

                    </div>
                    <div class="btn-group d-none d-sm-flex align-items-center">
                        <p class="mb-mm w-100">
                            <span>min bet: {{item?.min_bet}}</span>
                            <span>max bet: {{item?.max_bet}}</span>
                        </p>
                    </div>
                    <!-- status -->
                    <div class="SportEvent__market__statuslabel suspended" *ngIf="item?.isSuspend">
                        {{item?.susStatus}}
                    </div>
                    <!-- <div class="suspended" *ngIf="odds[item?.market_id]?.suspended == 1">SUSPENDED</div>
                    <div class="suspended" *ngIf="odds[item?.market_id]?.suspended == 0 && odds[item?.market_id]?.ball_running == 1">
                        BALL RUNNING
                    </div>
                    <div class="suspended" *ngIf="item?.bet_allow == 0">
                        SUSPENDED
                    </div> -->
                </div>
            </div>
        </div>
        
        <marquee *ngIf="isFancy ? item.fancy_type != 'LINE' : item.fancy_type == 'LINE' && odds[item?.market_id]?.message != null && odds[item?.market_id]?.message != ''" direction="left" behavior="scroll" id="news_100" style="color:red; font-weight:bold; font-size:11px; display:block;; ">{{odds[item?.market_id]?.message}}</marquee>

        <!-- betting table for mobile view -->
        <div class="row p-0 border-0 d-block d-sm-none mobile-view" *ngIf="betSlipData?.market_id == item?.market_id && betSlipData?.selection_id == item?.selection_id">
            <div class="col-12">
                <app-bet-slip [data]="betSlipData" (closeBet)="closeBet.emit($event)" (updateData)="updateData.emit($event)"
                    (changeExpo)="changeExpo.emit($event)">
                </app-bet-slip>
            </div>
        </div>
        <!-- betting table for mobile view -->

    </div>
</div>


    

<ng-template #bookModal>
    <div class="modal-header">
        <h4 class="modal-title mt-0">Book</h4>
        <button type="button" class="close" (click)="modalRef?.hide()">×</button>
    </div>
    <div class="modal-body">
        <div class="table-responsive">
            <table class="table mb-0">
                <thead>
                    <th>Run</th>
                    <th>Amount</th>
                </thead>
                <tbody>
                    <tr [ngClass]="(item.expose >= 0) ? 'back' : 'lay'" *ngFor="let item of fancyRun;trackBy:trackByIndex;">
                        <td>{{item.run}}</td>
                        <td class="" [ngClass]="(item.expose >= 0) ? 'green' : 'red'">{{item.expose}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row w-100">
            <div class="col-12 text-center">
                <button type="button" class="btn btn-outline-danger" (click)="modalRef?.hide()">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>